import { VideoRecorderScreenNavigationProps } from "./types"
import React from "react"
import VideoRecorder from "./video-recorder-screen"
import { PageRoot } from "~screens/page-root"


const VideoRecorderScreen: React.FC<VideoRecorderScreenNavigationProps> = () => {
  return (
    <PageRoot>
      <VideoRecorder />
    </PageRoot>
  )
}

export default VideoRecorderScreen
